'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);

/**
 * Configurations from server.
 *
 * @export
 * @class GraphStudioConfig
 */
var GraphStudioConfig = /*#__PURE__*/_createClass__default["default"](function GraphStudioConfig() {
  _classCallCheck__default["default"](this, GraphStudioConfig);
});

exports.GraphStudioConfig = GraphStudioConfig;
